// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrClass {
  width: 100%;
  z-index: 0;
}

h4 {
  color: var(--ion-color-primary);
}

span {
  background-color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-card3/custom-card3.component.scss"],"names":[],"mappings":"AAAA;EAEE,WAAA;EACA,UAAA;AAAF;;AAEA;EACE,+BAAA;AACF;;AACA;EACE,0CAAA;AAEF","sourcesContent":[".qrClass\n{\n  width: 100%;\n  z-index: 0;\n}\nh4{\n  color: var(--ion-color-primary);\n}\nspan{\n  background-color: var(--ion-color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
